import { render, staticRenderFns } from "./rankings.vue?vue&type=template&id=db984482&scoped=true"
import script from "./rankings.vue?vue&type=script&lang=js"
export * from "./rankings.vue?vue&type=script&lang=js"
import style0 from "./rankings.vue?vue&type=style&index=0&id=db984482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db984482",
  null
  
)

export default component.exports